const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed`, `e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed`, 1, 111), new Map([[`class`, `o-container--prose o-container--pad-inline u-pad-block-1`], [`alignment`, (context.has(`alignment`) ? context.get(`alignment`) : null)], [`ratio`, (context.has(`ratio`) ? context.get(`ratio`) : null)], [`caption`, (context.has(`caption`) ? context.get(`caption`) : null)]]), false, false, 1));
            }

            getTemplateName() {
                return `e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed`, ``);
            }
        }],
        [111, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <figure class="wp-block-embed is-type-video is-provider-youtube wp-block-embed-youtube
      wp-embed-aspect-`);
                this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, (((context.has(`ratio`))) ? (this.env.getFilter('default').traceableCallable(9, this.source)(...[(context.has(`ratio`) ? context.get(`ratio`) : null), `16-9`])) : (`16-9`)), `html`, null, true]));
                this.echo(` wp-has-aspect-ratio
      `);
                if ((context.has(`alignment`) ? context.get(`alignment`) : null)) {
                    this.echo(this.env.getFilter('escape').traceableCallable(10, this.source)(...[this.env, (context.has(`alignment`) ? context.get(`alignment`) : null), `html`, null, true]));
                }
                this.echo(`">
      <div class="wp-block-embed__wrapper">
        <iframe loading="lazy" title="Fluid Design Tools for a Responsive Design System World" src="https://www.youtube.com/embed/N0HeulsGVnM?feature=oembed" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="" width="500" height="281" frameborder="0"></iframe>
      </div>
      `);
                if ((context.has(`caption`) ? context.get(`caption`) : null)) {
                    this.echo(`        <figcaption class="wp-element-caption">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, (context.has(`caption`) ? context.get(`caption`) : null), `html`, null, true]));
                    this.echo(`</figcaption>
      `);
                }
                this.echo(`    </figure>
  `);
            }

            getTemplateName() {
                return `e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed');

let template = env.loadTemplate('e1cc08c9d36fe3538237f7567f73eee7b3540fbc826cde9511dcaac785d801ed');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/embed/youtube.twig", args: context }
     );
     return rendered;;
};